import { ADMIN_ROLES } from "../auth";

export const routes = {
    "/case/:ohCaseId/ppq": {
        title: "PPQ",
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name]
    },
    "/customer/:customerId/case/:ohCaseId/ppq": {
        title: "PPQ",
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name]
    },
    "/ppq/:customerId/:ppqId": {
        title: "PPQ",
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name]
    }
};
